import { ThumbsUpIcon } from '../../icons/ThumbsUpIcon'

export interface LikeButtonProps {
  value: number
  active?: boolean
  onClick: () => void
}

export function LikeButton({ value, active, onClick }: LikeButtonProps) {
  return (
    <button
      className={`button-svg button-impression ${
        active ? 'button-impression--positive-active' : ''
      }`}
      onClick={onClick}
      aria-label='like'
    >
      <ThumbsUpIcon />
      <span>{value}</span>
    </button>
  )
}
